module.exports = __webpack_public_path__ + "static/img/1091.de88f20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1091.jpg
// module id = 273
// module chunks = 0